import * as React from "react";

import GenLoadingSpinner from "./LoadingSpinner";

interface GenButtonProps {
  alertColor?: boolean;
  bottom_margin?: boolean;
  className?: string;
  confirmMessage?: string;
  destructive?: boolean;
  disabled?: boolean;
  highlighted?: boolean;
  href?: string;
  loading?: boolean;
  name: React.ReactNode;
  onClick?: (value: React.MouseEvent) => void;
  small?: boolean;
  spanClasses?: string;
  target?: "_blank";
}

export default function GenButton(props: GenButtonProps) {
  const internalOnClick = (value: React.MouseEvent) => {
    if (!props.disabled) {
      if (props.confirmMessage && !confirm(props.confirmMessage)) {
        return;
      }

      if(props.onClick) {
        props.onClick(value);
      }
      value.stopPropagation();
    }
  };

  let classes = "gen-button";
  let spanClasses = "bg-sky-600 border border-sky-600 button-name";

  if (props.spanClasses) {
    spanClasses = `${props.spanClasses} ${spanClasses}`;
  }

  if (props.disabled) {
    classes += " disabled cursor-not-allowed";
  }

  if (props.highlighted) {
    classes += " highlighted";

    if (!props.disabled) {
      spanClasses += " hover:bg-sky-500";
    }
  }

  if (props.destructive) {
    classes += " destructive";
  }

  if (props.small) {
    classes += " small";
  }

  if (props.alertColor) {
    classes += " alertColor";
  }

  if (props.bottom_margin) {
    classes += " bottom_margin";
  }

  if (props.className) {
    classes += ` ${props.className}`;
  }

  const innerSpan = <span className={spanClasses}>{props.loading ? <GenLoadingSpinner/> : props.name}</span>

  if (props.href) {
    return (
      <a className={classes} href={!props.disabled ? props.href : "#"}>{innerSpan}</a>
    )
  } else {
    return (
      <button className={classes} onClick={internalOnClick}>{innerSpan}</button>
    )
  }
}
